import React from 'react';
import { RiUserLine } from 'react-icons/ri';
import Card from '@/components/ui/cards/Card';

export default function ProfileTab({ customer }) {
  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      {/* Icon + heading */}
      <div className="flex items-center gap-2 mb-4">
        <RiUserLine className="text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Basic Information</h3>
      </div>

      <table className="w-full text-sm">
        <tbody>
          <tr className="border-b">
            <td className="py-4 w-1/4 text-gray-500">Name</td>
            <td className="py-4 w-3/4 font-medium break-all">
              {customer.name || '—'}
            </td>
          </tr>
          <tr className="border-b">
            <td className="py-4 w-1/4 text-gray-500">Email</td>
            <td className="py-4 w-3/4 font-medium break-all">
              {customer.email || '—'}
            </td>
          </tr>
          <tr>
            <td className="py-4 w-1/4 text-gray-500">Phone</td>
            <td className="py-4 w-3/4 font-medium break-all">
              {customer.phone_no || '—'}
            </td>
          </tr>
        </tbody>
      </table>
    </Card>
  );
}
